import { Table } from '@dreryk/react-components';

import { TrustedDevicesEmptyStatePlaceholder } from './TrustedDevicesEmptyStatePlaceholder';
import {
   useTrustedDevicesLazyLoadedDataConfigurationByCqrsQuery,
   useTrustedDevicesTableColumns,
} from './TrustedDevicesTable.hooks';
import { TrustedDevice } from './trustedDevices.types';

export const TrustedDevicesTable = (): JSX.Element => {
   const dataConfiguration = useTrustedDevicesLazyLoadedDataConfigurationByCqrsQuery();
   return (
      <>
         <Table<TrustedDevice>
            testId={'trustedDevices'}
            keyExtractor={'id'}
            columns={useTrustedDevicesTableColumns({ onDeviceRemoveSuccess: dataConfiguration.refetch })}
            dataConfiguration={dataConfiguration}
            placeholder={<TrustedDevicesEmptyStatePlaceholder />}
            // Infinity does not work with lazy loaded data configuration, thus big number
            pageSize={10000}
            compact
         />
      </>
   );
};
